// extracted by mini-css-extract-plugin
module.exports = {"container":"lX","title":"lY","button":"lZ","description":"l0","input":"l1","invalid":"l2","suggestion":"l3","reenterButton":"l4"};